import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import TypewriterComponent from 'typewriter-effect'
import { Particle } from '../../components'
import notFoundImg from '../../Assets/4044.svg'

const NotFound = () => {
    return (
        <Container fluid className="home-section" id="home">
            <Particle />
            <Container className="home-content">
                <Row>
                    <Col md={7} className="home-header">
                        <h1 style={{ paddingBottom: 15 }} className="heading">
                            <span className="wave" role="img" aria-labelledby="wave">😭</span> Oopss! <span className="wave" role="img" aria-labelledby="wave">😭</span>
                        </h1>

                        <h1 className="heading-name">
                            Page
                            <strong className="main-name"> Not Found</strong>
                        </h1>

                        <div style={{ padding: 50, textAlign: "left" }}>
                            <TypewriterComponent
                                options={{
                                    strings: [
                                        "Page Not Found !",
                                    ],
                                    autoStart: true,
                                    loop: true,
                                    deleteSpeed: 50,
                                }}
                            />
                        </div>
                    </Col>

                    <Col md={5} style={{ paddingBottom: 20 }}>
                        <img src={notFoundImg} alt="home pic" className="img-fluid" />
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}

export default NotFound
